export default __webpack_public_path__ + "static/media/dragon-study.26470906.jpg";